import { render, staticRenderFns } from "./ChangeProjectDialog.vue?vue&type=template&id=45a2a013&"
import script from "./ChangeProjectDialog.vue?vue&type=script&lang=ts&"
export * from "./ChangeProjectDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports